export default __webpack_public_path__ + "static/media/lato-regular.099cac12.woff2";